<template>
  <div class="input_group">
    <label :for="name">{{ label }}</label>
    <VueDatePicker :id="name" :name="name" :type="type" :placeholder="placeholder" :model-value="modelValue"
      @update:model-value="handleDate" :disabled="disabled" :range="range" auto-apply :close-on-auto-apply="true"
      :enable-time-picker="timepicker" time-picker-inline :format="format" locale="pt-BR" model-type="yyyy-MM-dd"></VueDatePicker>

      <span><i class="fa-regular fa-calendar-day"></i></span>

    <span v-if="error" class="error_message">{{ error[0] }}</span>
  </div>
</template>

<script setup>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { defineProps, defineEmits } from 'vue'

const emit = defineEmits(["update:modelValue"]);

const handleDate = (value) => {
  emit('update:modelValue', value);
}

const format = (date) => {
  let dateFormat;
  const today = new Date();

  if(date && props.range){
    const firstDate = date[0];
    const firstDay = (firstDate.getDate() <= 9) ? '0' + firstDate.getDate(): firstDate.getDate();
    const firstMonth = (firstDate.getMonth() + 1 <= 9) ? '0' + (firstDate.getMonth() + 1): firstDate.getMonth() + 1;
    const firstYear = firstDate.getFullYear();

    if (firstDate.toDateString() === today.toDateString()) {
      dateFormat = 'Hoje';
    }else {
      dateFormat = `${firstDay}/${firstMonth}/${firstYear}`;
    }

    const secondDate = date[1];
    const secondDay = (secondDate.getDate() <= 9) ? '0' + secondDate.getDate(): secondDate.getDate();
    const secondMonth = (secondDate.getMonth() + 1 <= 9) ? '0' + (secondDate.getMonth() + 1): secondDate.getMonth() + 1;
    const secondYear = secondDate.getFullYear();

    if (secondDate.toDateString() === today.toDateString()) {
      dateFormat += ' - Hoje';
    }else {
      dateFormat += ` - ${secondDay}/${secondMonth}/${secondYear}`;
    }

    if (firstDate.toDateString() === today.toDateString() && secondDate.toDateString() === today.toDateString()) {
      dateFormat = 'Hoje';
    }
  }else {
    const day = (date.getDate() <= 9) ? '0' + date.getDate(): date.getDate();
    const month = (date.getMonth() + 1 <= 9) ? '0' + (date.getMonth() + 1): date.getMonth() + 1;
    const year = date.getFullYear();
    const hour = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);

    if(props.timepicker){
      if (date.toDateString() === today.toDateString()) {
        dateFormat = `Hoje às ${hour}:${minutes}`;

      }else {
        dateFormat = `${day}/${month}/${year} ${hour}:${minutes}`;
      }
    }else {
      if (date.toDateString() === today.toDateString()) {
        dateFormat = 'Hoje';
      }else {
        dateFormat = `${day}/${month}/${year}`;
      }
    }
  }

  return dateFormat;
}

const props = defineProps({
  name: String,
  label: String,
  type: {
    type: String,
    default: 'text'
  },
  placeholder: String,
  modelValue: [Date],
  disabled: Boolean,
  error: String,
  range: Boolean,
  timepicker: Boolean,
  modelType: {
    type: String,
    default: 'yyyy-MM-dd hh:mm',
  }
})
</script>

<style scoped>
.input_group {
  display: flex;
  flex-direction: column;
  position: relative;
}

.input_group span {
    position: absolute;
    top: 15px;
    right: 15px;
    color: #a9a9a9;
}

.input_group label {
  margin-bottom: 4px;
  font-weight: 500;
  text-align: left;
}

.input_field:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.input_field:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.input_error {
  border: 1px #df2b2b solid;
}

.error_message {
  color: #df2b2b;
  font-weight: 500;
  margin-top: 4px;
}
</style>

<style>
.dp__input:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  border-color: #007bff;
}

.dp__menu {
  border-radius: 6px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 10%);
}

.dp__arrow_top {
  z-index: 9;
}

.dp__range_end, .dp__range_start, .dp__active_date, .dp__overlay_cell_active {
  background-color: #583a8e;
}

.dp__today {
  border-color: #d6cfe4;
}

.dp__range_start.dp__range_end {
  border-radius: 4px;
}

.dp__inner_nav svg {
  width: 14px;
}

.dp__input {
  padding: 10px 35px 10px 10px;
  border: 1px solid #d7d7d7;
  border-radius: 4px !important;
  font-size: 14px;
  font-weight: 500;
  color: #646464 !important;
  font-family: Poppins, Helvetica, Arial, sans-serif;
  height: 43px;
}

.dark .dp__input {
  background-color: #232932;
  border-color: #394251;
  color: #b5b9d0 !important;
}

.dark .dp__input:focus,
.dark .dp__input_focus {
    box-shadow: 0px 0px 0px 2px #655582 !important;
}

.dp__input_wrap svg {
  display: none;
}

.dp__calendar,
.dp__btn {
  font-size: 14px;
}
</style>